import { PartialRecursive } from '@bridebook/models/source/abstract/_';
import { IBucket } from '@bridebook/models/source/models/Countries/Buckets.types';

const result: PartialRecursive<IBucket['settings']> = {
  smartEmails: true,
  searchPresets: true,
};

export default result;
